export default [
    {
        name: 'Relatórios Contrato',
        url: '/gescon/relatorioscontratos',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-CONT-REL-00',
        badge: {
            variant: 'primary',
            text: 'GESCON'
        }
    }
]
